import {ITeleport} from '../levels/level';

export class Brick {
  empty = true;
  color = '';
  type: 'empty'|'wall'|'port' = 'empty';
  port?: ITeleport;
}
